<template>
  <div class="About Page">
    <h1>{{ page.admin[lang].title }}</h1>
    <div class="About__text" v-html="page[lang].text" />
    <div class="About__infos">
      <div class="About__title">{{ trans('title') }}</div>
      <div class="About__infos-container"> 
        <div class="About__row">
          <div class="About__text" v-html="trans('rows_1_1')" />
          <div class="About__text" v-html="trans('rows_2_1')" />
          <div class="About__text" v-html="trans('rows_3_1')" />
          <div class="About__text" v-html="trans('rows_4_1')" />
          <div class="About__text" v-html="trans('rows_5_1')" />
        </div>
        <div class="About__row">
          <div class="About__text" v-html="trans('rows_1_2')" />
          <div class="About__text" v-html="trans('rows_2_2')" />
          <div class="About__text" v-html="trans('rows_3_2')" />
          <div class="About__text" v-html="trans('rows_4_2')" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Page from '@/core/mixins/Page'
export default {
  name: 'About',
  mixins: [Page],
  translations: {
    fr: {
      title: 'Renseignements',
      rows_1_1: 'Bibliothèque du Parlement',
      rows_1_2: 'Office national du film du Canada',
      rows_2_1: '<a href="mailto:info@parl.gc.ca">info@parl.gc.ca',
      rows_2_2: '1-800-267-7710',
      rows_3_1: '1-866-599-4999',
      rows_3_2: '514-287-9000',
      rows_4_1: '613-992-4793',
      rows_4_2: '<a href="http://www.onf.ca" target="_blank">onf.ca',
      rows_5_1: '<a href="https://decouvrez.parl.ca" target="_blank">decouvrez.parl.ca',
    },
    en: {
      title: 'For More Information',
      rows_1_1: 'Library of Parliament',
      rows_1_2: 'National Film Board of Canada',
      rows_2_1: '<a href="mailto:info@parl.gc.ca">info@parl.gc.ca',
      rows_2_2: '1-800-267-7710',
      rows_3_1: '1-866-599-4999',
      rows_3_2: '514-287-9000',
      rows_4_1: '613-992-4793',
      rows_4_2: '<a href="http://www.nfb.ca" target="_blank">nfb.ca',
      rows_5_1: '<a href="https://learn.parl.ca" target="_blank">learn.parl.ca',
    },
  },
  methods:{
    openLink(link) {
      window.open(link,'_blank')
    },
  },
}
</script>

<style lang="stylus">
@import '~@/config/Settings'
@import '~@/commons/stylus/Media-queries'

.About
  &__text
    font-size 18px
    font-weight 500
    line-height 24px
    letter-spacing .05em
    max-width 800px

  &__title
    font-size 20px
    font-weight bold
    line-height 24px
    letter-spacing .05em
    padding 0 0 16px

  &__infos-container
    display flex
    flex-direction row
    justify-content flex-start

  &__row
    padding-right 48px


</style>
